'use client';
var classes = {"root":"m-d57069b5","viewport":"m-c0783ff9","viewportInner":"m-f8f631dd","scrollbar":"m-c44ba933","thumb":"m-d8b5e363","corner":"m-21657268"};

export default classes;
//# sourceMappingURL=ScrollArea.module.mjs.map
